<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Anexos</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="pagamento.anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        ><i class="fa fa-plus"></i> Inserir
                                        Anexo</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <pagamento-anexo-download
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                ></pagamento-anexo-download>
                                <pagamento-anexo-excluir
                                    :pagamento="pagamento"
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                    @obterPagamentoAtualizado="
                                        obterPagamentoAtualizado()
                                    "
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirAnexo"
                                ></pagamento-anexo-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <pagamento-anexo-form
            ref="pagamentoAnexoForm"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
        ></pagamento-anexo-form>
    </div>
</template>

<script>
import PagamentoAnexoDownload from './PagamentoAnexoDownload'
import PagamentoAnexoForm from './PagamentoAnexoForm'
import PagamentoAnexoExcluir from './PagamentoAnexoExcluir'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'anexoTipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        inserirAnexo() {
            this.$refs.pagamentoAnexoForm.mostrarModal = true
        },

        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        }
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return (
                this.$temAcesso('APPSE-FORN-PAG-03') &&
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO)
            )
        },

        mostrarBtnExcluirAnexo() {
            return (
                this.$temAcesso('APPSE-FORN-PAG-03') &&
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO)
            )
        }
    },

    created() {},

    components: {
        PagamentoAnexoForm,
        PagamentoAnexoDownload,
        PagamentoAnexoExcluir
    }
}
</script>
